import script from "./NavPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NavPage.vue?vue&type=script&setup=true&lang=js"

import "./NavPage.vue?vue&type=style&index=0&id=2200e0b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2200e0b8"]])

export default __exports__